export default class FormSlide {
    constructor(slide) {
        this.input = slide.querySelector('input[type="email"]');
        this.submitbtn = slide.querySelector('[data-submit]');

        this.input.addEventListener('keyup', this.checkNext.bind(this));
    }

    validate() {
        if (this.input.value) {
            return this.input.checkValidity();
        } else {
            return true; //Deze stap is skippable
        }
    }

    checkNext() {
        if(this.submitbtn) {
            this.submitbtn.disabled = !this.input.checkValidity();
        }
    }
}